import React, { useEffect } from 'react';
import NoImagePNG from '../../images/no-image.png';

function Carousel({ options, onClickFunction }) {
    useEffect(() => {
        if (options.id != null)
            window.bronson.$$('#' + options.id).component('carousel');
    }, [options.id]);

    let next = (
        <div className="c-carousel__controls  js-carousel__controls">
            <button
                className="c-carousel__button  c-carousel__button--prev  js-carousel__button--prev"
                type="button"
            >
                <span className="c-carousel__button-label"></span>
            </button>
            <button
                className="c-carousel__button  c-carousel__button--next  js-carousel__button--next"
                type="button"
            >
                <span className="c-carousel__button-label"></span>
            </button>
        </div>
    );

    if (options.next == false) {
        next = null;
    }

    const getImages = () => {
        if (!options.images || !options.images.length) {
            return (
                <div className="c-carousel__item" key="1">
                    <img
                        className="c-carousel__image"
                        src={NoImagePNG}
                        sizes="100vw"
                        alt=""
                    ></img>
                </div>
            );
        } else {
            return options.images.map((optionValue, index) => (
                <div
                    className="c-carousel__item"
                    key={options.id + '-' + index}
                >
                    <img
                        className="c-carousel__image"
                        data-flickity-lazyload={optionValue}
                        sizes="100vw"
                    ></img>
                </div>
            ));
        }
    };

    return (
        <div
            className="c-carousel js-carousel"
            id={options.id}
            onClick={onClickFunction}
            data-carousel-lazy-load="3"
        >
            {getImages()}
            {next}
        </div>
    );
}

export default Carousel;
